<div class="container-fluid">
  <div class="row">
    <div class="col-sm-12 d-flex align-items-center justify-content-center flex-column">
      <div class="col-sm-12 col-md-5 d-flex flex-column align-items-center justify-content-center">
        <img src="assets/img/oops.png" class="oops">
        <div class="not-found">{{'Page not found' | translate}}</div>
      </div>
    </div>
  </div>
</div>
